import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import NavBar from "./components/Layout/navbar";
import Home from "./components/pages/Home/Home";
import Agents from "./components/pages/Agents/Agents";
import InfoAgent from "./components/pages/Agents/InfoAgent";
import NotFound from "./components/Layout/NotFound";

function App() {
  return (
    <Router>
      <div className='App bg-gray-900'>
        <NavBar></NavBar>

        <Switch>
          <Route exact path='/' component={Home}></Route>
          <Route exact path='/agents' component={Agents}></Route>
          <Route exact path='/agents/:name' component={InfoAgent}></Route>
          <Route component={NotFound}></Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
